/* global window self */
export function isBrowser() {
    return typeof window !== 'undefined';
}
/* eslint-disable no-restricted-globals */
export function isWebWorker() {
    var _a;
    return (typeof self === 'object' &&
        ((_a = self === null || self === void 0 ? void 0 : self.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'DedicatedWorkerGlobalScope');
}
/* eslint-enable no-restricted-globals */
export function isNode() {
    var _a;
    return typeof process !== 'undefined' && ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) != null;
}
export function isProduction() {
    return process.env.NODE_ENV === 'production';
}
//# sourceMappingURL=env-util.js.map